module.exports = "<a href ng-click=$ctrl.openChangeOrganizationModal()>{{ $ctrl.textButton }}</a> ";